import { AUTH_TOKEN_COOKIE } from "@/constants";
import Cookies from "js-cookie";
// This script is used temporarily to migrate our auth tokens to the extened Scope
export async function removeLegacyAuthToken(): Promise<void> {
	Cookies.remove(AUTH_TOKEN_COOKIE);
}
